import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { IS_LEGACY_DOMAIN, toNewDomain } from '../../utils/brand';
import { CloseButton, BaseButton, useIsMobile } from '@repo/common';
import MigrationBottomSheet from './MigrationBottomSheet';

const SEEN_KEY = 'migration:popup-seen';

const MigrationModal = () => {
  const isMobile = useIsMobile();
  const hero = `${process.env.REACT_APP_ASSETS_URL}/img-migration-modal.svg`;
  const [open, setOpen] = useState(IS_LEGACY_DOMAIN);

  const close = () => setOpen(false);

  if (!open) return null;

  if (isMobile) {
    return createPortal(
      <MigrationBottomSheet onClose={close} />,
      document.body,
    );
  }

  return createPortal(
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-surface-lightgray60 px-5'>
      <div className='flex flex-col items-center relative w-full max-w-[500px] rounded-[30px] bg-grayscale-gray01 px-[60px] py-10 text-center shadow-popup-01'>
        {/* 닫기 */}
        <div className='absolute right-6 top-6'>
          <CloseButton onClick={close} type='light' />
        </div>

        <div className='flex flex-col items-center gap-4 pb-10'>
          {/* 로고 패널 */}
          <img src={hero} alt='Hero Banner' />

          {/* 본문 */}
          <p className='typo-b14Strong text-text-primary'>
            O!ng Lab is now{' '}
            <a href={toNewDomain('/')} className='underline'>
              Koready
            </a>
            .
            <br />
            Your account, including all past reservations and personal data, has
            been seamlessly migrated to our new domain. Please bookmark our new
            address for future visits! Note that this old site will officially
            shut down on August 31, 23:59:59.
          </p>

          <p className='typo-b14 text-text-secondary'>
            Need help? Reach out to{' '}
            <a href='mailto:hello@ko-ready.com' className='underline'>
              hello@ko-ready.com
            </a>
          </p>
        </div>

        {/* CTA */}
        <div className='w-full'>
          <BaseButton
            type='primary'
            size='xl'
            hideIcon
            width='100%'
            onClick={() => {
              window.location.href = toNewDomain();
            }}
          >
            Continue to New Website
          </BaseButton>
        </div>
        {/* 모바일용 stay */}
        <button
          type='button'
          onClick={close}
          className='mt-3 text-[13px] text-grayscale-gray05 underline md:hidden'
        >
          stay
        </button>
      </div>
    </div>,
    document.body,
  );
};

export default MigrationModal;
